export function createAiOrchestrator(context = {}) {
  const {
    elements,
    getAiModuleApi,
    ensureAiModuleReady,
    showToast,
    canAccessFeature = () => false,
    openMembershipCenter = () => {}
  } = context;

  let entrypointsBound = false;
  let warmupScheduled = false;

  function bindLazyEntrypoints() {
    if (entrypointsBound) return;
    entrypointsBound = true;

    elements.aiFloatBtn?.addEventListener('pointerdown', () => {
      if (getAiModuleApi()?.isAiModuleInitialized?.()) return;
      ensureAiModuleReady().catch(() => {});
    }, { capture: true, passive: true });

    elements.aiFloatBtn?.addEventListener('click', async (e) => {
      if (!canAccessFeature('canAccessAi')) {
        e.preventDefault();
        e.stopPropagation();
        showToast?.('Free 档位不支持 AI 助手，请升级会员');
        openMembershipCenter?.();
        return;
      }
      if (getAiModuleApi()?.isAiModuleInitialized?.()) return;
      e.preventDefault();
      e.stopPropagation();
      try {
        const mod = await ensureAiModuleReady();
        mod?.toggleAiChatPanel?.();
      } catch (error) {
        showToast?.('AI 模块加载失败');
      }
    }, true);

    elements.settingsBtn?.addEventListener('click', async (e) => {
      if (getAiModuleApi()?.isAiModuleInitialized?.()) return;
      e.preventDefault();
      e.stopPropagation();
      try {
        const mod = await ensureAiModuleReady();
        mod?.openSettingsPanel?.();
      } catch (error) {
        showToast?.('设置模块加载失败');
      }
    }, true);

    scheduleWarmup();
  }

  function scheduleWarmup() {
    if (warmupScheduled) return;
    warmupScheduled = true;
    const warm = () => ensureAiModuleReady().catch(() => {});
    if (typeof window !== 'undefined' && typeof window.requestIdleCallback === 'function') {
      window.requestIdleCallback(warm, { timeout: 6000 });
      return;
    }
    setTimeout(warm, 2200);
  }

  return {
    bindLazyEntrypoints,
    scheduleWarmup
  };
}
